import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { postListStyles } from './post-list.css';
import { renderPostListPresentation, type PostListProps } from './post-list-presentation';
import { MarkdownDoc } from '../../data/markdownEngine';

@customElement('post-list')
export class PostList extends LitElement {
  static styles = [postListStyles];

  @property({ type: Array }) posts: MarkdownDoc[] = [];

  private openPost(doc: MarkdownDoc) {
    this.dispatchEvent(
      new CustomEvent('open-doc', {
        detail: { doc },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    const props: PostListProps = {
      posts: this.posts,
      onOpenPost: (doc: MarkdownDoc) => this.openPost(doc),
    };

    return renderPostListPresentation(props);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'post-list': PostList;
  }
}
